import { c as create_ssr_component, v as validate_component } from "../../../../chunks/ssr.js";
import { B as BookOpenPageVariant, S as ServicePageTemplate } from "../../../../chunks/ServicePageTemplate.js";
import { A as AirplaneTakeoff } from "../../../../chunks/AirplaneTakeoff.js";
import { C as CheckDecagram } from "../../../../chunks/CheckDecagram.js";
import { A as AirplaneClock } from "../../../../chunks/AirplaneClock.js";
import { C as CopyCard } from "../../../../chunks/CopyCard.js";
import { B as Button } from "../../../../chunks/Button.js";
const _page_svelte_svelte_type_style_lang = "";
const css = {
  code: ".button.svelte-1mvhfrc{width:max-content}",
  map: null
};
let programs = true;
let pricingPackage = false;
let professionalProgram = false;
let background_center = false;
let hero_image = "/g2g.webp";
let h1 = "Commercial Pilot Program";
let hero_paragraph_content = "Obtaining your Commercial Pilot License requires students dedicating their time and skills to  achieve a professional certification. Obtaining a commercial pilots license involves accumulating a specific number of flight hours and mastering several  professional maneuvers and techniques.  Once a student has earned this certification, they are eligible for various career possibilities such as flight instruction, aerial photography, cargo transport, charter operations, banner towing, corporate flight and more.";
let center_img_seperating_section = false;
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let roadmap_stages = [
    [
      {
        text: "Time building",
        icon: AirplaneClock
      },
      {
        text: "Commercial Pilot Training",
        icon: BookOpenPageVariant
      },
      {
        text: "Commercial Pilot Checkride",
        icon: AirplaneTakeoff
      },
      {
        text: "Commercial Pilot Achieved",
        icon: CheckDecagram
      }
    ]
  ];
  let second_center_img_seperating_section = {
    src: "/lets_go.webp",
    alt: "Piper 100i taxiing"
  };
  let prerequisites = {
    eligibility: [
      "Are over 18 years of age",
      "Proficient in the English Language",
      "Hold at least a private pilot certificate",
      "Receive the required training and a logbook endorsement from an authorized instructor",
      "Pass the required knowledge test on the aeronautical knowledge areas",
      "Meet the aeronautical experience requirements that apply to the aircraft category and class rating sought",
      "Pass the required practical test",
      "Comply with the federal aviation regulations that apply to commercial flight"
    ],
    proficiency: [
      "Preflight preparation",
      "Preflight procedures",
      "Airport operations",
      "Takeoffs, landings, and go-arounds",
      "Performance maneuvers",
      "Ground reference maneuvers",
      "Navigation",
      "Slow flight and stalls",
      "Emergency operations",
      "High-altitude operations",
      "Post-flight procedures"
    ],
    experience: [
      "250 hours of flight time",
      "100 hours, of which 50 hours must be in airplanes",
      "100 hours of pilot-in-command flight time which includes at least 50 hours in cross-country flight",
      "20 hours of training",
      "10 hours of instrument training using a view-limiting device",
      "10 hours of training in a complex airplane, a turbine-powered airplane, or a technically advanced airplane (TAA) or any combination thereof",
      "One 2-hour cross country flight in daytime conditions that consists of a total straight-line distance of more than 100 nautical miles",
      "One 2-hour cross country flight in nighttime conditions that consists of a total straight-line distance of more than 100 nautical miles",
      "3 hours with an instructor in preparation for the practical test within the preceding 2 calendar months",
      "10 hours of solo time or 10 hours of flight performing the duties of pilot in command with an instructor",
      "One cross-country flight of not less than 300 nautical miles total distance, with landings at a minimum of three points, one of which is a straight-line distance of at least 250 nautical miles",
      "5 hours in night VFR conditions with 10 takeoffs and 10 landings at an airport with an operating control tower"
    ]
  };
  let faqs = [
    {
      question: "What is a commercial pilot?",
      answer: "A commercial pilot is a licensed aviator who is authorized to be compensated for their flying services. They can be employed as pilots for various purposes, including airline, cargo, or charter operations. Commercial pilots have more advanced training and experience compared to private or sport pilots.",
      opened: false
    },
    {
      question: "How to become a commercial pilot?",
      answer: "To become a commercial pilot, you typically need to follow these steps: \n\na. Obtain a private pilot license. \n\nb. Build flight experience, often requiring a minimum of 250 flight hours. \n\nc. Complete additional training to meet the commercial pilot certification requirements. \n\nd. Pass a written knowledge test and a practical flight test. \n\ne. Obtain a Class II medical certificate. \n\nf. Apply for and receive your commercial pilot certificate.",
      opened: false
    },
    {
      question: "How long does it take to become a commercial pilot?",
      answer: "The time it takes to become a commercial pilot can vary widely, but it often takes several years. The duration depends on factors like your availability for training, the flight school you choose, and the specific pathway you follow.",
      opened: false
    },
    {
      question: "How much do commercial pilots make?",
      answer: "Commercial pilot salaries can vary significantly depending on factors such as the type of aircraft flown, the employer, experience, and location. On average, commercial pilots in the United States earn a median annual salary in the range of $60,000 to $80,000 or more.",
      opened: false
    },
    {
      question: "How many flight hours to become a commercial pilot?",
      answer: "To qualify for a commercial pilot certificate in the United States, you typically need a minimum of 250 total flight hours, including a specified number of hours in various categories of flight (e.g., solo, cross-country, night, etc.).",
      opened: false
    },
    {
      question: "What is a Part 61 Commercial Pilots Course?",
      answer: "<b>A Part 61 flight training program requires that students obtain a Private Pilot certificate, Instrument rating, and meet the requirements to take a Commercial (usually Single Engine Land) exam – which requires a minimum of 250 hours.</b> \n\nPart 61 flight training offers more flexibility, as students can attend part-time as their schedule allows. There is no specific training program, and this unstructured approach allows a highly personalized training program to directly meet the specific student’s needs. \n\nAt the end of the course, students who are looking to obtain their Airline Transport Pilot (ATP) license will, once they have obtained their SEL COMM certificate, will generally obtain a Multi-Engine Land (MEL) add-on.",
      opened: false
    },
    {
      question: "What is a Part 141 Commercial Pilots Course?",
      answer: "A Part 141 course can only be offered by FAA approved schools, and also requires that students obtain a Private Pilot certificate, Instrument rating, and meet the requirements to take a Commercial (usually Single Engine Land) exam – which requires a minimum of 190 hours. The courses typically are compressed and are ‘linear’ in their completion requirements – i.e. lesson 3 has to be fully completed prior to starting lesson 4. \n\nA Part 141 course is highly structured, and can be the preferred choice for students who want to obtain their SEL COMM certificate in the shortest possible timeframe.",
      opened: false
    },
    {
      question: "Can I Mix and Match Part 61 and 141 courses?",
      answer: "In order to qualify for a Part 141 SEL COMM, you are required to take the part 141 Instrument rating and SEL COMM courses. Students can take a Part 61 Private Pilot and then switch to a Part 141 Instrument course. Students who take a Part 61 Instrument rating are NOT eligible for a Part 141 COMM certificate.",
      opened: false
    },
    {
      question: "Why do I want to take a Part 141 Course?",
      answer: "The biggest differentiator between the Part 61 and 141 COMM rating is the reduction in the number of hours – Part 61 requires 250 hours, while Part 141 COMM only needs 190 hours; This directly translates to less time and money.",
      opened: false
    },
    {
      question: "Are there any differences between a Part 61 and Part 141 Commercial License?",
      answer: "No – both licenses provide students with an FAA COMM license.",
      opened: false
    }
  ];
  $$result.css.add(css);
  return `${$$result.head += `<!-- HEAD_svelte-r895cn_START -->${$$result.title = `<title>Commercial Pilot | First Landings Aviation</title>`, ""}<meta name="description" content="First Landings Aviation commercial pilot training"><!-- HEAD_svelte-r895cn_END -->`, ""} ${validate_component(ServicePageTemplate, "ServicePageTemplate").$$render(
    $$result,
    {
      background_center,
      faqs,
      programs,
      pricingPackage,
      professionalProgram,
      hero_image,
      h1,
      hero_paragraph_content,
      roadmap_stages,
      center_img_seperating_section,
      prerequisites,
      second_center_img_seperating_section
    },
    {},
    {
      three: () => {
        return `<div slot="three">${validate_component(CopyCard, "CopyCard").$$render(
          $$result,
          {
            src: "/rob_checkride.webp",
            alt: "Commercial pilot checkride"
          },
          {},
          {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-1nlm994">A check-ride is an essential part of the pilot certification process
        that includes both a flight test and an oral exam. During a check-ride,
        a designated pilot examiner (DPE) assesses the pilot&#39;s ability to
        operate an aircraft safely and proficiently. The examination covers
        various aspects, including flight maneuvers, navigation, emergency
        procedures, communication skills, and a thorough understanding of
        aviation regulations.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-5aur3t">Checkride Information</div>`;
            }
          }
        )}</div>`;
      },
      two: () => {
        return `<div slot="two">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
          text: () => {
            return `<div slot="text">The minimum commercial pilot age limit is 18 years of age. In order to
        begin your training you must be able to read, write, speak and
        understand English proficiently. Before you do your check-ride, you&#39;ll
        need to obtain a medical certificate (second class or higher) from an
        FAA approved aviation medical examiner (AME) in the United States. You
        will also need to show proof of U.S. Citizenship or TSA approval (which
        requires a valid and current US visa) as well as your private pilot
        certificate and knowledge test results.
        <br> <br> <div class="button svelte-1mvhfrc">${validate_component(Button, "Button").$$render($$result, { href: "/contact-us", color: "blue" }, {}, {
              default: () => {
                return `Book Now`;
              }
            })}</div></div>`;
          },
          heading: () => {
            return `<div slot="heading" data-svelte-h="svelte-gjaehl">What Do You Need to Start?</div>`;
          }
        })}</div>`;
      },
      one: () => {
        return `<div slot="one">${validate_component(CopyCard, "CopyCard").$$render(
          $$result,
          {
            src: "/cessna_rotate.webp",
            alt: "Cessna 172 rotating"
          },
          {},
          {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-48ctng">The initial stage of your journey to becoming a commercial pilot is
        obtaining your Private Pilot Certificate. Once you have obtained your
        Private Pilot License with enough hours and training in high performance
        maneuvers you can work towards your commercial pilot license which
        allows you to transport persons and property for hire. In this course
        you will learn to perfect in flight and ground reference maneuvers that
        build your confidence and proficiency as a professional pilot. It is
        highly advisable that you obtain your instrument rating before beginning
        your commercial pilots training to avoid significant limitations on your
        privilege. The type of aircraft used in this course are Piper and Cessna
        aircraft, some of which include full-glass flight decks.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-1kkxrt0">Course Description</div>`;
            }
          }
        )}</div>`;
      }
    }
  )}`;
});
export {
  Page as default
};
